/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ReplaySubject, forkJoin, Observable, of, timer } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap } from 'rxjs/operators';
import { DataPickerService } from '../../../core/services/data_picker/data_picker.service';
import { ContactInfoService } from '../../contact-info/contact-info.component.service';
import { CreateForm, CreateFormField } from '../data-picker.interface';
import { LineItemPickerComponent } from 'app/components/line-item-picker/line-item-picker.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { LineItemPickerColumnType, LineItemPickerColumns, LineItemPickerOptions } from 'app/components/line-item-picker/line-item-picker.interface';
import { LineItemPickerService } from 'app/components/line-item-picker/line-item-picker.service';
import { LineItemService } from 'app/core/services/lineitem/lineitem.service';
import { AssetsService } from 'app/core/services/assets/assets.service';

@Component({
    selector: 'quick-create-asset',
    templateUrl: './quick-create-asset.component.html',
    styleUrls: ['./quick-create-asset.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickCreateAssetComponent implements OnInit, OnChanges {
    @Input() formReset: boolean = false;
    @Input() formSubmit: boolean = false;
    @Input() prefillValues: any = null;
    @Input() formVisibility: boolean = false;
    @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
    @Output() formValidationEmitter: EventEmitter<boolean> = new EventEmitter();

    assetForm: UntypedFormGroup = null;
    categories: Observable<any[]> = null;
    organizations: Observable<any[]> = null;
    customers: Observable<any[]> = null;
    properties: Observable<any[]> = null;
    assetInspectionForms: Observable<any[]> = null;
    categoryOptions: any[] = [];
    organizationOptions: any[] = [];
    customerOptions: any[] = [];
    propertyOptions: any[] = [];
    assetInspectionFormOptions: any[] = [];
    pagination: any = {
        loadingIndex: 1,
        totalPage: 1,
        keyword: ''
    };
    customerPagination: any = {
        loadingIndex: 1,
        totalPage: 1,
        keyword: ''
    };
    propertyPagination: any = {
        loadingIndex: 1,
        totalPage: 1,
        keyword: ''
    };
    loading: boolean = false;
    customerloading: boolean = false;
    propertyLoading: boolean = false;
    isFormLoaded: boolean = false;
    selectedProduct: any = null;
    createAsset: CreateForm[] = [{
        headerName: 'Primary Information',
        headerDisplayKey: 'text.primary_information',
        canShow: true,
        formFields: [{
            labelName: 'Product',
            labelDisplayKey: 'product.text',
            fieldId: 'product',
            fieldType: 'choose_input',
            inputType: 'text',
            formControlName: 'product',
            placeHolder: 'Choose Product',
            placeHolderDisplayKey: 'asset.form.placeholder.choose_product'
        }, {
            labelName: 'Asset Code',
            labelDisplayKey: 'asset_code',
            fieldId: 'assetCode',
            fieldType: 'input',
            inputType: 'text',
            formControlName: 'assetCode',
            placeHolder: 'Eg: EA0012',
            placeHolderDisplayKey: 'asset.new.asset_code.placeholder',
            isMandatory: true,
            validationText: 'field is required',
            validationTextKey: 'editor.required.message'
        }, {
            labelName: 'Asset Name',
            labelDisplayKey: 'asset_name',
            fieldId: 'assetName',
            fieldType: 'input',
            inputType: 'text',
            formControlName: 'assetName',
            placeHolder: 'Eg: Generator',
            placeHolderDisplayKey: 'asset.new.asset_name.placeholder',
            isMandatory: true,
            validationText: 'field is required',
            validationTextKey: 'editor.required.message'
        }, {
            labelName: 'Asset Serial No.',
            labelDisplayKey: 'asset.new.form.label.asset_serial_number',
            fieldId: 'assetSerialNumber',
            fieldType: 'input',
            inputType: 'text',
            formControlName: 'assetSerialNumber',
            placeHolder: 'Eg: AC001',
            placeHolderDisplayKey: 'asset.new.asset_serial_number.placeholder'
        }, {
            labelName: 'Asset Category',
            labelDisplayKey: 'text.asset_category',
            fieldId: 'assetCategory',
            fieldType: 'autocomplete',
            inputType: 'text',
            formControlName: 'assetCategory',
            placeHolder: 'Select Category',
            placeHolderDisplayKey: 'text.select_category',
            observable: this.categories,
            oberservableKey: 'category_name',
            isMandatory: true,
            validationText: 'field is required',
            validationTextKey: 'editor.required.message'
        }, {
            labelName: 'Asset Ownership',
            labelDisplayKey: 'text.asset_ownership',
            fieldId: 'assetOwnership',
            fieldType: 'dropdown',
            formControlName: 'assetOwnership',
            placeHolder: 'Choose an option',
            placeHolderDisplayKey: 'text.choose_option',
            isMandatory: false,
            data: [{
                displayKey: 'text.owned_by_customer',
                displayName: 'Owned By Customer',
                value: true
            }, {
                displayKey: 'text.owned_by_us',
                displayName: 'Owned By Us',
                value: false
            }]
        }, {
            labelName: 'Asset Inspection Form',
            labelDisplayKey: 'text.asset_inspection_form',
            fieldId: 'assetInspectionForm',
            fieldType: 'autocomplete',
            inputType: 'text',
            formControlName: 'assetInspectionForm',
            placeHolder: 'Choose an option',
            placeHolderDisplayKey: 'text.choose_option',
            isMandatory: false,
            observable: this.assetInspectionForms,
            oberservableKey: 'asset_form_name',
            oberservableValue: 'asset_form_uid',
            valueSubject: new ReplaySubject<string | null>(),
          },]
    }, {
        headerName: 'Customer Information',
        headerDisplayKey: 'create.customer.customer.header',
        canShow: true,
        formFields: [ {
            labelName: 'Choose Organization',
            labelDisplayKey: 'choose.organization',
            fieldId: 'organization',
            fieldType: 'lazyautocomplete',
            inputType: 'text',
            formControlName: 'organization',
            placeHolder: 'Choose Organization',
            placeHolderDisplayKey: 'choose.organization',
            observable: this.organizations,
            oberservableKey: 'organization_name',
            oberservableValue: 'organization_uid',
            allowLoading: true,
            allowLazyLoading: true,
            valueSubject: new ReplaySubject<string | null>(),
            showIf: this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar'),
        }, {
            labelName: 'Choose Customer',
            labelDisplayKey: 'text.choose_customer',
            fieldId: 'customer',
            fieldType: 'lazyautocomplete',
            inputType: 'text',
            formControlName: 'customer',
            placeHolder: 'Choose Customer',
            placeHolderDisplayKey: 'text.choose_customer',
            observable: this.customers,
            oberservableKey: 'customer_first_name',
            oberservableValue: 'customer_uid',
            allowLoading: true,
            allowLazyLoading: true,
            valueSubject: new ReplaySubject<string | null>(),
            showIf: this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar'),
        }, {
            labelName: 'Choose Propety',
            labelDisplayKey: 'text.choose_property',
            fieldId: 'property',
            fieldType: 'lazyautocomplete',
            inputType: 'text',
            formControlName: 'property',
            placeHolder: 'Choose Property',
            placeHolderDisplayKey: 'text.choose_property',
            observable: this.properties,
            oberservableKey: 'property_name',
            oberservableValue: 'property_uid',
            allowLoading: true,
            allowLazyLoading: true,
            valueSubject: new ReplaySubject<string | null>(),
            showIf: this.utilityService.hasModuleAccess('PROPERTY', false, 'from_sidebar'),
        }]
    }, {
        headerName: 'Service Address',
        headerDisplayKey: 'text.service_address',
        headerType: 'address',
        formGroupName: 'serviceAddress',
        canShow: true,
        formFields: [],
        contactFields: {
            contactFirstName: true,
            contactLastName: true,
            contactEmail: true,
            contactPhone: true,
            street: true,
            enableMapsAutoComplete: true,
            canTruncate: true,
            landmark: false,
            city: true,
            state: true,
            country: true,
            zipcode: true,
            latitude: false,
            longitude: false
        }
    }, {
        headerName: 'Billing Address',
        headerDisplayKey: 'billing.address.text',
        headerType: 'address',
        formGroupName: 'billingAddress',
        canShow: true,
        isMatCheck: true,
        formControlName: 'sameAddress',
        matCheckLabel: 'text.same_as_service_address',
        formFields: [],
        contactFields: {
            contactFirstName: true,
            contactLastName: true,
            contactEmail: true,
            contactPhone: true,
            street: true,
            enableMapsAutoComplete: false,
            landmark: false,
            city: true,
            state: true,
            country: true,
            zipcode: true,
            latitude: false,
            longitude: false
        }
    }];
    formControls: any[] = [{
        formControlName: 'product',
        value: '',
        validators: []
    }, {
        formControlName: 'assetCode',
        value: '',
        validators: [Validators.required]
    }, {
        formControlName: 'assetName',
        value: '',
        validators: [Validators.required]
    }, {
        formControlName: 'assetSerialNumber',
        value: '',
        validators: []
    }, {
        formControlName: 'organization',
        value: null,
        validators: []
    }, {
        formControlName: 'customer',
        value: null,
        validators: []
    }, {
        formControlName: 'property',
        value: null,
        validators: []
    }, {
        formControlName: 'assetCategory',
        value: null,
        validators: [Validators.required]
    }, {
        formControlName: 'assetOwnership',
        value: null,
        validators: []
    }, {
        formControlName: 'assetInspectionForm',
        value: null,
        validators: []
    }, {
        formControlName: 'serviceAddress',
        controls: []
    }, {
        formControlName: 'billingAddress',
        controls: []
    }, {
        formControlName: 'sameAddress',
        value: true,
        validators: []
    }];
    orgParamObj: any = {
        'count': 10,
        'page': 1,
        'filter.keyword': '',
        'sort': 'ASC',
        'filter.is_active': true,
        'sort_by': 'organization_name'
    };
    customerParamObj: any = {
        'count': 10,
        'page': 1,
        'filter.keyword': '',
        'sort': 'ASC',
        'filter.is_active': true,
        'sort_by': 'customer_first_name'
    };
    propertyParamObj: any = {
        'count': 10,
        'page': 1,
        'filter.keyword': '',
        'sort': 'ASC',
        'filter.is_active': true,
        'sort_by': 'property_name'
    };
    assetInspectionFormParamObj: any = {
        count: 100,
        page: 1,
        sort: 'DESC',
        sort_by: 'created_at',
    };
    pickerAPIUrls: any;

    assetSerialNoCtrl: FormControl = new FormControl('', {asyncValidators: this.assetSerialValidator(), updateOn: 'change'});

    constructor(
        private utilityService: UtilityService,
        private dataCollectorService: DataCollectorService,
        private localisationService: LocalisationService,
        private pickerService: DataPickerService,
        private contactInfoService: ContactInfoService,
        private toast: HotToastService,
        private zuperDialogService: ZuperDialogService,
        private lineItemPickerService: LineItemPickerService,
        private lineItemService: LineItemService,
        private eleRef: ElementRef, 
        private assetService: AssetsService) {
        this.assetForm = this.pickerService.createFormControls(this.formControls);
    }

    ngOnInit(): void {
        this.localisationService.setDefaultLanguage();
        this.pickerAPIUrls = this.pickerService.pickerAPIUrls;
        if (this.formVisibility) {
            this.updateCreateFormVisibility();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.formReset?.currentValue === true) {
            this.resetForm();
        }

        if (changes?.formSubmit?.firstChange === false && changes?.formSubmit?.currentValue === true) {
            this.submitQuickCreateForm();
        }

        if (changes?.formVisibility?.firstChange === false && changes?.formVisibility?.currentValue === true) {
            this.updateCreateFormVisibility();
        }
    }

    updateCreateFormVisibility(): void {
        if (!this.isFormLoaded) {
            this.isFormLoaded = true;
            this.openQuickCreateForm();
        } else {
            this.setAssetFromPrefillValue();
        }
    }

    openQuickCreateForm(): void {
        this.updatePrefillValuesFilter();
        this.getData();
        this.assetForm.get('sameAddress').valueChanges.subscribe((value: any) => {
            if (!value) {
                this.updateBillingAddress();
            }
        });
    }

    updatePrefillValuesFilter(): void {
        if (this.prefillValues) {
            Object.keys(this.prefillValues).forEach((key: string) => {
                const prefillValue: any = this.prefillValues[key];
                if (key === 'organization' && prefillValue) {
                    this.orgParamObj['filter.organization_uid'] = prefillValue;
                }
                if (key === 'customer') {
                    if (prefillValue) {
                        this.customerParamObj['filter.customer_uid'] = prefillValue;
                    } else if (!prefillValue && this.prefillValues?.['organization']) {
                        this.customerParamObj['filter.customer_organization'] = this.prefillValues?.['organization'];
                    }
                }
                if (key === 'property') {
                    if (prefillValue) {
                        this.propertyParamObj['filter.property_uid'] = prefillValue;
                    } else if (!prefillValue && this.prefillValues?.['organization']) {
                        this.propertyParamObj['filter.organization'] = this.prefillValues?.['organization'];
                    } else if (!prefillValue && this.prefillValues?.['customer']) {
                        this.propertyParamObj['filter.customer'] = this.prefillValues?.['customer'];
                    }
                }
            });
        }
    }

    resetForm(): void {
        this.assetForm.reset({
            sameAddress: true
        });
    }

    updateBillingAddress(): void {
        const serviceAddress: any = this.assetForm.get('serviceAddress').value;
        this.assetForm.get('billingAddress').patchValue(serviceAddress);
    }

    getErrorMessageKey(field: CreateFormField): string {
        if (this.assetForm.get(field.formControlName).hasError('required')) {
            return field.validationTextKey;
        }

        return '';
    }

    showError(formControlName: string): boolean {
        const formControl: AbstractControl = this.assetForm.get(formControlName);
        return formControl?.touched && !formControl?.valid;
    }

    checkFieldsContainerVisibility(header: CreateForm): boolean {
        if (header.isMatCheck) {
            const formControl: AbstractControl = this.assetForm.get(header.formControlName);
            return formControl ? !formControl.value : true;
        }
        return true;
    }

    getData(): void {
        this.orgParamObj['page'] = 1;
        this.customerParamObj['page'] = 1;
        const urlParams = this.utilityService.constructParam(this.orgParamObj);
        const customerUrlParams = this.utilityService.constructParam(this.customerParamObj);
        const propertyUrlParams = this.utilityService.constructParam(this.propertyParamObj);
        const assetInspectionFormUrlParams = this.utilityService.constructParam(this.assetInspectionFormParamObj)
        const payload: any = {
            'filter.is_active': true
        };

        forkJoin([
            this.dataCollectorService.getData(this.pickerAPIUrls.assetsCategoryUrl, payload),
            this.dataCollectorService.getData(this.pickerAPIUrls.organizationUrl, urlParams),
            this.dataCollectorService.getData(this.pickerAPIUrls.customerUrl, customerUrlParams),
            this.dataCollectorService.getData(this.pickerAPIUrls.propertyUrl, propertyUrlParams),
            this.dataCollectorService.getData(this.assetService.getInspectionForms(), assetInspectionFormUrlParams)
        ]).subscribe(
            ([categories, organizations, customers, properties, assetInspectionForm]: any) => {
                if (categories) {
                    this.categoryOptions = categories.data;
                    this.categories = this.assetForm.get('assetCategory').valueChanges.pipe(
                        startWith(''),
                        map(() => this.categoryOptions)
                    );
                }
                if (organizations) {
                    this.pagination.loadingIndex = organizations.current_page;
                    this.pagination.totalPage = organizations.total_pages;
                    this.organizationOptions = organizations.data;
                    this.organizations = this.assetForm.get('organization').valueChanges.pipe(
                        startWith(''),
                        map((value: any) => this.organizationOptions)
                    );
                    this.setAssetFromPrefillValue();
                }
                if (customers) {
                    this.customerPagination.loadingIndex = customers.current_page;
                    this.customerPagination.totalPage = customers.total_pages;
                    this.customerOptions = customers.data;
                    this.customers = this.assetForm.get('customer').valueChanges.pipe(
                        startWith(''),
                        map((value: any) => this.customerOptions)
                    );
                    this.setAssetFromPrefillValue();
                }
                if (properties) {
                    this.propertyPagination.loadingIndex = properties.current_page;
                    this.propertyPagination.totalPage = properties.total_pages;
                    this.propertyOptions = properties.data;
                    this.properties = this.assetForm.get('property').valueChanges.pipe(
                        startWith(''),
                        map((value: any) => this.propertyOptions)
                    );
                    this.setAssetFromPrefillValue();
                }
                if (assetInspectionForm) {
                    this.assetInspectionFormOptions = assetInspectionForm.data;
                    this.assetInspectionForms = this.assetForm.get('assetInspectionForm').valueChanges.pipe(
                        startWith(''),
                        map((value: any) => this.assetInspectionFormOptions)
                    );
                }
            }, (_error: any) => {
            });
    }

    setAssetFromPrefillValue(): void {
        if (this.prefillValues?.['organization'] && this.organizationOptions?.length) {
            setTimeout(() => {
                const organizationControl: AbstractControl = this.assetForm?.get('organization');
                organizationControl?.setValue(this.prefillValues['organization']);
                organizationControl?.disable();
            }, 100);
        }
        if (this.prefillValues?.['customer'] && this.customerOptions?.length) {
            setTimeout(() => {
                const customerControl: AbstractControl = this.assetForm?.get('customer');
                customerControl?.setValue(this.prefillValues['customer']);
                customerControl?.disable();
            }, 100);
        }
        if (this.prefillValues?.['property'] && this.propertyOptions?.length) {
            setTimeout(() => {
                const propertyControl: AbstractControl = this.assetForm?.get('property');
                propertyControl?.setValue(this.prefillValues['property']);
                propertyControl?.disable();
            }, 100);
        }
        setTimeout(() => {
            this.updateBillingAddressValue();
            this.updateServiceAddressValue();
        }, 100);
    }

    getObservable(type: string): Observable<any[]> {
        if (type === 'assetCategory') {
            return this.categories;
        } else if (type === 'organization') {
            return this.organizations;
        } else if (type === 'customer') {
            return this.customers;
        } else if (type === 'property') {
            return this.properties;
        } else if (type === 'assetInspectionForm') {
            return this.assetInspectionForms;
        }
    }

    onSearch(valueSubject: ReplaySubject<string | null>, type: string): void {
        if (type === 'organization') {
            this.updateOrganizations(valueSubject);
        } else if (type === 'customer') {
            this.updateCustomers(valueSubject);
        } else if (type === 'property') {
            this.updateProperties(valueSubject);
        }
    }

    onClear(type: string): void {
        if (type === 'organization') {
            this.organizations = this.getOrganizations('');
            this.updateAssetOrganizationValue();
        } else if (type === 'customer') {
            this.customers = this.getCustomers('');
            this.updateAssetCustomerValue();
        } else if (type === 'property') {
            this.properties = this.getProperties('');
            this.updateAssetPropertyValue();
        }
    }

    updateOrganizations(valueSubject: ReplaySubject<string | null>): void {
        if (valueSubject) {
            this.organizations = valueSubject.pipe(
                distinctUntilChanged(),
                debounceTime(250),
                filter(value => (value !== null && value !== undefined)),
                switchMap(term => this.getOrganizations(term))
            );
        }
    }

    getOrganizations(input: string): Observable<any[]> {
        this.pagination.keyword = input ? input : '';
        this.orgParamObj['filter.keyword'] = this.pagination.keyword;
        this.orgParamObj['page'] = 1;
        const urlParams = this.utilityService.constructParam(this.orgParamObj);
        this.loading = true;
        return this.dataCollectorService.getData(this.pickerAPIUrls.organizationUrl, urlParams)
            .pipe(
                catchError(() => of([])),
                map((response) => {
                    this.pagination.loadingIndex = response.current_page;
                    this.pagination.totalPage = response.total_pages;
                    this.organizationOptions = response.data;
                    this.loading = false;
                    return response.data;
                }),
            );
    }

    updateCustomers(valueSubject: ReplaySubject<string | null>): void {
        if (valueSubject) {
            this.customers = valueSubject.pipe(
                distinctUntilChanged(),
                debounceTime(250),
                filter(value => (value !== null && value !== undefined)),
                switchMap(term => this.getCustomers(term))
            );
        }
    }

    getCustomers(input: string): Observable<any[]> {
        this.customerPagination.keyword = input ? input : '';
        this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
        this.customerParamObj['page'] = 1;
        const urlParams = this.utilityService.constructParam(this.customerParamObj);
        this.customerloading = true;
        return this.dataCollectorService.getData(this.pickerAPIUrls.customerUrl, urlParams)
            .pipe(
                catchError(() => of([])),
                map((response) => {
                    this.customerPagination.loadingIndex = response.current_page;
                    this.customerPagination.totalPage = response.total_pages;
                    this.customerOptions = response.data;
                    this.customerloading = false;
                    return response.data;
                }),
            );
    }

    updateProperties(valueSubject: ReplaySubject<string | null>): void {
        if (valueSubject) {
            this.properties = valueSubject.pipe(
                distinctUntilChanged(),
                debounceTime(250),
                filter(value => (value !== null && value !== undefined)),
                switchMap(term => this.getProperties(term))
            );
        }
    }

    getProperties(input: string): Observable<any[]> {
        this.propertyPagination.keyword = input ? input : '';
        this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
        this.propertyParamObj['page'] = 1;
        const urlParams = this.utilityService.constructParam(this.propertyParamObj);
        this.propertyLoading = true;
        return this.dataCollectorService.getData(this.pickerAPIUrls.propertyUrl, urlParams)
            .pipe(
                catchError(() => of([])),
                map((response) => {
                    this.propertyPagination.loadingIndex = response.current_page;
                    this.propertyPagination.totalPage = response.total_pages;
                    this.propertyOptions = response.data;
                    this.propertyLoading = false;
                    return response.data;
                }),
            );
    }

    onScrollToEnd(type: string): void {
        if (type === 'organization') {
            if (this.pagination.loadingIndex < this.pagination.totalPage) {
                this.pagination.loadingIndex++;
                this.fetchMore();
            }
        } else if (type === 'customer') {
            if (this.customerPagination.loadingIndex < this.customerPagination.totalPage) {
                this.customerPagination.loadingIndex++;
                this.fetchMoreCustomer();
            }
        } else if (type === 'property') {
            if (this.propertyPagination.loadingIndex < this.propertyPagination.totalPage) {
                this.propertyPagination.loadingIndex++;
                this.fetchMoreProperty();
            }
        }
    }

    fetchMore(): void {
        this.loading = true;
        this.orgParamObj['filter.keyword'] = this.pagination.keyword;
        this.orgParamObj['page'] = this.pagination.loadingIndex;
        const urlParams = this.utilityService.constructParam(this.orgParamObj);

        this.dataCollectorService.getData(this.pickerAPIUrls.organizationUrl, urlParams).subscribe(
            (organizations: any) => {
                this.loading = false;
                this.organizationOptions = this.organizationOptions.concat(organizations.data);
                this.organizations = this.assetForm.get('organization').valueChanges.pipe(
                    startWith(''),
                    map((value: any) => this.organizationOptions)
                );
            }, (_error: any) => {
                this.loading = false;
            });
    }

    fetchMoreCustomer(): void {
        this.customerloading = true;
        this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
        this.customerParamObj['page'] = this.customerPagination.loadingIndex;
        const urlParams = this.utilityService.constructParam(this.customerParamObj);

        this.dataCollectorService.getData(this.pickerAPIUrls.customerUrl, urlParams).subscribe(
            (customers: any) => {
                this.customerloading = false;
                this.customerOptions = this.customerOptions.concat(customers.data);
                this.customers = this.assetForm.get('customer').valueChanges.pipe(
                    startWith(''),
                    map((value: any) => this.customerOptions)
                );
            }, (_error: any) => {
                this.customerloading = false;
            });
    }

    fetchMoreProperty(): void {
        this.propertyLoading = true;
        this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
        this.propertyParamObj['page'] = this.propertyPagination.loadingIndex;
        const urlParams = this.utilityService.constructParam(this.propertyParamObj);

        this.dataCollectorService.getData(this.pickerAPIUrls.propertyUrl, urlParams).subscribe(
            (properties: any) => {
                this.propertyLoading = false;
                this.propertyOptions = this.propertyOptions.concat(properties.data);
                this.properties = this.assetForm.get('property').valueChanges.pipe(
                    startWith(''),
                    map((value: any) => this.propertyOptions)
                );
            }, (_error: any) => {
                this.propertyLoading = false;
            });
    }

    submitQuickCreateForm(): void {
        this.assetForm.markAllAsTouched();
        if (this.assetForm.get('sameAddress').value) {
            this.updateBillingAddress();
        }
        if (this.assetForm.valid && this.assetSerialNoCtrl.valid) {
            this.createNewAsset();
        } else {
          this.assetSerialNoCtrl.markAsTouched();
            this.pickerService.scrollToFirstInvalidControl(this.eleRef.nativeElement);
            this.formValidationEmitter.emit(false);
        }
    }

    isLoading(type: string): boolean {
        if (type === 'organization') {
            return this.loading;
        } else if (type === 'customer') {
            return this.customerloading;
        } else if (type === 'property') {
            return this.propertyLoading;
        }
        return false;
    }

    isOptionalAddress(): boolean {
        const formValue: any = this.assetForm.getRawValue();
        if (formValue?.customer || formValue?.organization || formValue?.property) {
            return false;
        }
        return true;
    }

    onChooseInput(type: string): void {
        if (type === 'product') {
            this.openLineItemPicker();
        }
    }

    clearInput(type: string): void {
        if (type === 'product') {
            this.selectedProduct = null;
            this.assetForm.get(type).setValue('');
        }
    }

    changeLazyAutoCompleteValue(event: any, type: string): void {
        if (event && type === 'customer') {
            this.updateAssetCustomerValue(event);
        } else if (event && type === 'organization') {
            this.updateAssetOrganizationValue(event);
        } else if (event && type === 'property') {
            this.updateAssetPropertyValue(event);
        }
    }

    updateAssetCustomerValue(event?: any): void {
        if (!this.assetForm.value.organization && !this.assetForm.value.property) {
            this.assetForm.patchValue({
              property: null
            });
            if (event) {
                this.propertyParamObj['filter.customer'] = event?.customer_uid;
            } else {
                delete this.propertyParamObj?.['filter.customer'];
            }
        }
        this.updateBillingAddressValue();
        this.updateServiceAddressValue();
    }

    updateAssetOrganizationValue(event?: any): void {
        this.assetForm.patchValue({
          customer: null,
          property: null
        });
        if (this.assetForm?.get('customer')?.disabled) {
            this.assetForm?.get('customer')?.enable();
            delete this.customerParamObj?.['filter.customer_uid'];
        }
        if (this.assetForm?.get('property')?.disabled) {
            this.assetForm?.get('property')?.enable();
            delete this.propertyParamObj?.['filter.property_uid'];
        }
        if (event) {
            this.customerParamObj['filter.customer_organization'] = event?.organization_uid;
            this.propertyParamObj['filter.organization'] = event?.organization_uid;
        } else {
            delete this.customerParamObj?.['filter.customer_organization'];
            delete this.propertyParamObj?.['filter.organization'];
        }
        this.customers = this.getCustomers('');
        this.properties = this.getProperties('');
        this.updateBillingAddressValue();
        this.updateServiceAddressValue();
    }

    updateAssetPropertyValue(event?: any): void {
        this.updateBillingAddressValue();
        this.updateServiceAddressValue();
    }

    updateServiceAddressValue(): void {
      let addressFormValue: any = null;
      const formValue: any = this.assetForm?.getRawValue();
      if (formValue?.property) {
        const property: any = this.getPropertyDetails();
        addressFormValue = this.contactInfoService.populateAddressFields(property?.property_address);
      } else if (formValue?.customer) {
        const customer: any = this.getCustomerDetails();
        addressFormValue = this.contactInfoService.populateAddressFields(customer?.customer_address);
      } else if (formValue?.organization) {
        const organization: any = this.getOrganizationDetails();
        addressFormValue = this.contactInfoService.populateAddressFields(organization?.organization_address);
      } else {
        addressFormValue = this.contactInfoService.populateAddressFields(null);
      }
      setTimeout(() => {
        this.assetForm.get('serviceAddress')?.patchValue(addressFormValue);
      });
    }

    updateBillingAddressValue(): void {
      this.assetForm.get('sameAddress').setValue(false);
      let addressFormValue: any = null;
      const formValue: any = this.assetForm?.getRawValue();
      if (formValue?.organization) {
        const organization: any = this.getOrganizationDetails();
        addressFormValue = this.contactInfoService.populateAddressFields(organization?.organization_billing_address);
      } else if (formValue?.customer) {
        const customer: any = this.getCustomerDetails();
        addressFormValue = this.contactInfoService.populateAddressFields(customer?.customer_billing_address);
      } else {
        addressFormValue = this.contactInfoService.populateAddressFields(null);
        this.assetForm.get('sameAddress').setValue(true);
      }
      setTimeout(() => {
        this.assetForm.get('billingAddress')?.patchValue(addressFormValue);
      });
    }

    getCustomerDetails(): any {
      const customerUID: string = this.assetForm?.getRawValue()?.customer;
      if (customerUID) {
        return this.customerOptions?.find(customer => customer.customer_uid === customerUID) || null;
      }
      return null;
    }

    getOrganizationDetails(): any {
      const organizationUID: string = this.assetForm?.getRawValue()?.organization;
      if (organizationUID) {
        return this.organizationOptions?.find(organization => organization.organization_uid === organizationUID) || null;
      }
      return null;
    }

    getPropertyDetails(): any {
      const propertyUID: string = this.assetForm?.getRawValue()?.property;
      if (propertyUID) {
        return this.propertyOptions?.find(property => property.property_uid === propertyUID) || null;
      }
      return null;
    }

    //#region Line Item (Product Picker)
    openLineItemPicker(): void {
      this.lineItemPickerService.selectedLineItems.next(this.selectedProduct ? [this.selectedProduct] : []);
      const lineItemDialog: any = this.zuperDialogService.openCustom(LineItemPickerComponent,
        {
          extraClass: 'line-item-picker-container',
          data: {
            options: {
              multipleLineItems: false,
              remoteData: {
                dataUrl: this.lineItemService.lineItemAPIUrls.productUrl,
                params: {
                  'filter.product_type': 'PRODUCT'
                }
              },
              pickerType: 'modal',
              columns:  this.getLineItemsProductColumns(),
              addFromProductGroup: false,
              filters: {
                search: {
                  enabled: true
                },
                productType: {
                  enabled: false
                },
                category: {
                  enabled: true
                },
                location: {
                  enabled: false
                },
                availability: {
                  enabled: true
                }
              },
              header: {
                isEnabled: true,
                headerDisplayKey: 'lineitem.picker.header.choose_products',
                headerDisplayName: 'Choose Product'
              },
              footer: {
                isEnabled: true,
                buttonDisplayKey: 'lineitem.picker.add.product_text',
                buttonDisplayName: 'Add Product'
              }
            } as LineItemPickerOptions
          }
        });
      lineItemDialog.disableClose = true;
      const onAddItemClicked: any = this.lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
        lineItemDialog.close(response);
      });
      lineItemDialog.afterClosed().subscribe((lineItems: any) => {
        onAddItemClicked.unsubscribe();
        if(lineItems?.length){
          this.selectedProduct = lineItems[0];
          this.assetForm.get('product').setValue(this.selectedProduct.product_name);
          if(this.assetForm.get('assetName').invalid){
            this.assetForm.get('assetName').setValue(this.selectedProduct.product_name);
          }
          if(this.assetForm.get('assetCode').invalid){
            this.assetForm.get('assetCode').setValue(this.selectedProduct.product_id || '');
          }
          // if(!this.assetForm.get('assetSerialNumber').value){
          //   this.assetForm.get('assetSerialNumber').setValue(this.selectedProduct.serial_nos?.[0] || '');
          // }
          if(!this.assetSerialNoCtrl.value) {
            this.assetSerialNoCtrl.setValue(this.selectedProduct.serial_nos?.[0] || '');
          }
        }
        this.lineItemPickerService.selectedLineItems.next([]);
      });
    }

    getLineItemsProductColumns(): LineItemPickerColumns[] {
      return [{
        type: LineItemPickerColumnType.LINE_ITEM,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.CATEGORY,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.BRAND,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.SPECIFICATION,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.LOCATION,
        isEditable: true
      },
      {
        type: LineItemPickerColumnType.SERIAL_NO,
        isEditable: true,
        isRequired: false,
        multiple: false
      }];
    }
    //#endregion

    createNewAsset(): void {
        const payLoad: any = this.getAssetModel(this.assetForm.getRawValue());
        this.dataCollectorService.postData(this.pickerAPIUrls.assetUrl, payLoad)
            .subscribe(
                (response: any) => {
                    this.toast.success(response.message);
                    this.dataCollectorService.getData(this.pickerAPIUrls.assetUrl + '/' + response?.data?.asset_uid).subscribe(
                        (asset: any) => {
                            this.eventEmitter.emit({ value: [asset.data] });
                        }, (_error: any) => {
                        });
                }, (_error: any) => {
                    this.formValidationEmitter.emit(false);
                }
            );
    }

    getAssetModel(formValue: any): any {
        const assetLocation: any = this.contactInfoService.getContactInfoAddressModel(formValue['serviceAddress']);
        const billingAddress: any = this.contactInfoService.getContactInfoAddressModel(formValue['billingAddress']);
        return {
            asset: {
                asset_code: formValue?.assetCode ?? null,
                asset_name: formValue?.assetName ?? null,
                asset_quantity: 1,
                asset_inspection_form: formValue?.assetInspectionForm?.asset_form_uid ?? null,
                asset_serial_number: this.assetSerialNoCtrl.value ?? null,
                asset_location: this.utilityService.isValidObjectAllProperties(assetLocation) ? {} : assetLocation,
                useful_life: {
                    type: 'YEARS'
                },
                purchase_price: this.selectedProduct?.price ?? null,
                asset_category: formValue?.assetCategory?.category_uid ?? null,
                owned_by_customer: formValue?.assetOwnership ?? false,
                asset_image: null,
                residual_price: null,
                asset_description: null,
                billing_address: this.utilityService.isValidObjectAllProperties(billingAddress) ? null : billingAddress,
                organization: this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar') ? (formValue?.organization || null) : null,
                property: this.utilityService.hasModuleAccess('PROPERTY', false, 'from_sidebar') ? (formValue?.property || null) : null,
                parent_asset: null,
                asset_product: this.selectedProduct?.product_uid ?? null,
                location_uid: this.selectedProduct?.location_uid ?? null,
                asset_status: '',
                customer: this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar') ? (formValue?.customer || null) : null,
                asset_parts: [],
                custom_fields: []
            }
        };
    }

  private assetSerialValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) {
        return of(null);
      }
      return timer(500).pipe(switchMap(() => {
        return this.dataCollectorService.getData(this.assetService.assetsUrl, { 'filter.serial_no': (control.value).trim() }).pipe(map((result: any) => {
          if (result.data.length > 0) {
            return { assetSerialExists: true };
          }
          return null;
        }));
      }));
    };
  }
}
